var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClarityEyeShowSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_427)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4133 11.6867C20.1667 7.53335 16.2267 5.02002 11.8667 5.02002C7.50667 5.02002 3.56 7.53335 1.33333 11.6867L1.14667 12L1.32 12.32C3.56667 16.4734 7.50667 18.9867 11.8667 18.9867C16.2267 18.9867 20.1733 16.5067 22.4133 12.32L22.5867 12L22.4133 11.6867ZM11.8667 17.62C8.11333 17.62 4.66667 15.5267 2.66667 12C4.66667 8.47335 8.11333 6.38002 11.8667 6.38002C15.62 6.38002 19.0267 8.48002 21.06 12C19.0267 15.5267 15.6133 17.62 11.8667 17.62Z",
    fill: "#5A5C66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.06 16.5933C14.5858 16.5933 16.6333 14.5458 16.6333 12.02C16.6333 9.49421 14.5858 7.44666 12.06 7.44666C9.53422 7.44666 7.48666 9.49421 7.48666 12.02C7.48666 14.5458 9.53422 16.5933 12.06 16.5933Z",
    fill: "#5A5C66"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_427"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClarityEyeShowSolid);
export default __webpack_public_path__ + "static/media/clarity_eye-show-solid.08433f46259f9bd1841aa57d251d34cc.svg";
export { ForwardRef as ReactComponent };